/**
 * Logger utility for conditional debug logging
 * Only logs in development mode
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  warn: (...args: any[]) => {
    console.warn(...args);
  },
  
  error: (...args: any[]) => {
    console.error(...args);
  },
  
  // Socket-specific logging (can be toggled)
  socket: (...args: any[]) => {
    if (isDevelopment && import.meta.env.VITE_DEBUG_SOCKET === 'true') {
      console.log('[Socket]', ...args);
    }
  }
};
